export const theme = {
  main: {
    background: '#414141',
    fontFamily: "'Open Sans', sans-serif",
    textColor: '#f9f9f9'
  }
}
